var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useContext, useEffect, useState } from 'react';
import { ComponentContext } from '../Context/ComponentContext';
import { TelemetryEvents } from '../Resources/TelemetryEvents';
export function useLoginOnStartup(shouldLogin, options = {}) {
    const { authClient, telemetryClient } = useContext(ComponentContext);
    const [user, setUser] = useState(null);
    useEffect(() => {
        telemetryClient.trackTrace({ message: TelemetryEvents.SessionStarted });
        if (user)
            return telemetryClient.setAuthenticatedUserContext(user.id);
    }, []);
    useEffect(() => {
        if (shouldLogin === false)
            return;
        if (user)
            return telemetryClient.setAuthenticatedUserContext(user.id);
        authClient
            .isLoggedIn()
            .then((isLoggedIn) => __awaiter(this, void 0, void 0, function* () {
            if (isLoggedIn) {
                const loggedInUser = yield authClient.getUser();
                setUser(loggedInUser);
                return;
            }
            authClient.login(options).catch();
        }))
            .catch(() => {
            authClient.login(options).catch();
        });
    }, [authClient, shouldLogin, telemetryClient, user]);
    return [user];
}
//# sourceMappingURL=useLoginOnStartup.js.map